import { wsService } from "./wsService";
import sections from "@/constants/sections";
import ChequesState from "@/constants/chequesStates";

const section = sections.SECTION_CHECKS;

const BBVA = 17;

const PROVINCIA = 14;

const ICBC = 15;

function filter(param = { enable: true }) {
  return wsService.make_post_request(section + "/list", param);
}

function create(param = {}) {
  return wsService.make_post_request(section + "/create", param);
}

function update(param = {}) {
  return wsService.make_put_request(section + "/update", param);
}

function remove(param = {}) {
  return wsService.make_delete_request(section + "/delete", param);
}

function changeState(param = {}) {
  return wsService.make_post_request(section + "/performe_action", param);
}

function getStates() {
  return wsService.make_get_request(section + "/get_states");
}

function rollbackState(param = {}) {
  return wsService.make_post_request(section + "/rollback_state", param);
}

function to_expire(param = {}) {
  return wsService.make_post_request(section + "/to_expire", param);
}

function getClassState(state) {
  switch (state) {
    case ChequesState.STATE_SIN_IMPUTAR:
      return "state_cheque en_cartera";
    case ChequesState.STATE_EN_CARTERA:
      return "state_cheque en_cartera";
    case ChequesState.STATE_DEPOSITADO:
      return "state_cheque depositado";
    case ChequesState.STATE_NEGOCIADO:
    case ChequesState.STATE_ACREDITADO:
    case ChequesState.STATE_ACREDITED:
      return "state_cheque acreditado";
    case ChequesState.STATE_COBRADO_VENTANILLA:
      return "state_cheque cobrado_por_ventanilla";
    case ChequesState.STATE_DEBITADO:
      return "state_cheque debitado";
    case ChequesState.STATE_ANULADO:
    case ChequesState.STATE_RECHAZADO:
      return "state_cheque rechazado";
    case ChequesState.STATE_UTILIZADO:
      return "state_cheque utilizado";
    case ChequesState.STATE_VENCIDO:
      return "state_cheque vencido";

    default:
      return "state_cheque";
  }
}

function getStartIndex(bank) {
  if (bank == null) {
    return 0;
  }
  switch (parseInt(bank.code)) {
    case ICBC:
    case BBVA:
      return 1;
    case PROVINCIA: 
      return 3;
    default:
      return 0;
  }
}

function getAmount(bank, row, is_own = false) {
  if (bank == null) {
    return "";
  }
  switch (parseInt(bank.code)) {
    case ICBC:
    case BBVA:
      console.log("getAmount",row[6], row[5], is_own);
      return !is_own
        ? row[6].toString().replace("$", "").replace(/\./g, "").replace(",", ".")
        : row[5].toString().replace("$", "").replace(/\./g, "").replace(",", ".");
    case PROVINCIA:
      return row[2].toString().replace(/\./g, "").replace(",", ".");
    default:
      return "";
  }
}

function getNumber(bank, row, is_own = false) {
  if (bank == null) {
    return "";
  }
  switch (parseInt(bank.code)) {
    case ICBC:
    case BBVA:
      return !is_own ? row[8].toString() : row[7].toString();
    case PROVINCIA:
      return row[4].toString();
    default:
      return "";
  }
}

function getEmissionDate(bank, row, is_own = false) {
  if (bank == null) {
    return "";
  }
  switch (parseInt(bank.code)) {
    case ICBC:
    case BBVA:
      console.log("getEmissionDate",row[3], row[4], is_own);
      return !is_own ? formatDate(row[3]) : formatDate(row[4]);
    case PROVINCIA:
      return formatDate(row[5]);
    default:
      return "";
  }
}

function getPaymentDate(bank, row, is_own = false) {
  if (bank == null) {
    return "";
  }
  switch (parseInt(bank.code)) {
    case ICBC:
    case BBVA:
      console.log("getPaymentDate",row[4], row[2], is_own);
      return !is_own ? formatDate(row[4]) : formatDate(row[2]);
    case PROVINCIA:
      return formatDate(row[6])
    default:
      return "";
  }
}

function getBank(bank, row, list_banks = [], is_own = false) {
  if (bank == null) {
    return "";
  }
  switch (parseInt(bank.code)) {
    case ICBC:
    case BBVA:
      if (row[2] == "BANCO SANTANDER RIO S.A.") {
        row[2] = "BANCO SANTANDER ARGENTINA S.A.";
      }
      console.log("getBank",row[2], list_banks);
      return list_banks.filter((b) => b.clean_name == row[2])[0];
    default:
      return "";
  }
}

function getEmitterName(bank, row, is_own = false) {
  if (bank == null) {
    return "";
  }
  switch (parseInt(bank.code)) {
    case ICBC:
    case BBVA:
      return row[0];
    case PROVINCIA: 
      return row[0];
    default:
      return "";
  }
}

function formatDate(date) {
  //caso de fecha en formato objeto
  try {
    if (!isNaN(date.getTime())) {
      // Obtiene el año, el mes y el día de la fecha
      const año = date.getFullYear();
      const mes = String(date.getMonth() + 1).padStart(2, "0"); // Se agrega 1 porque los meses van de 0 a 11
      const dia = String(date.getDate()).padStart(2, "0");

      // Formatea la fecha en el formato YYYY-MM-DD
      return `${año}-${mes}-${dia}`;
    }
  } catch (e) {
    //console.log(e);
  }

  var parts;
  //caso de fecha en formato dd-mm-yyyy
  if (date.includes("-")) {
    // Dividir el string en día, mes y año
    parts = date.split("-");
    // Crear una nueva fecha con las partes en el orden deseado (año-mes-día)
    return parts[2] + "-" + parts[1] + "-" + parts[0];
  }

  if (date.includes("/")) {
    // Dividir el string en día, mes y año
    parts = date.split("/");
    // Crear una nueva fecha con las partes en el orden deseado (año-mes-día)
    return parts[2] + "-" + parts[1] + "-" + parts[0];
  }
}

export const checkService = {
  section,
  filter,
  remove,
  create,
  update,
  changeState,
  getStates,
  getClassState,
  rollbackState,
  to_expire,
  getStartIndex,
  getAmount,
  getNumber,
  getEmissionDate,
  getPaymentDate,
  getBank,
  getEmitterName,
};
